var map = {
	"./kd-logo.png": 8401,
	"./ks-logo.png": 5344,
	"./ksdeploy-logo.png": 2615,
	"./sort_asc.png": 7394,
	"./sort_asc_disabled.png": 8775,
	"./sort_both.png": 4556,
	"./sort_desc.png": 6510,
	"./sort_desc_disabled.png": 3619
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7910;